/* eslint-disable indent */
import React from "react";

// Alias React 19 symbols to React 18 symbols before the library loads
const originalSymbolFor = Symbol.for;
Symbol.for = function (key) {
    if (key === "react.transitional.element") {
        return originalSymbolFor("react.element");
    }
    return originalSymbolFor(key);
};

if (React && !React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) {
    React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = {
        recentlyCreatedOwnerStacks: 0,
        A: {
            getOwner: () => null
        }
    };
}
